import { Box, Flex } from "@chakra-ui/react";
import React from "react";

type CustomInsightsResultCardProps = {
  children: React.ReactNode;
  footer?: React.ReactNode;
  bodyRef?: React.RefObject<HTMLDivElement>;
  mt?: number | string;
};

export default function CustomInsightsResultCard({
  children,
  footer,
  bodyRef,
  mt = 4,
}: CustomInsightsResultCardProps): React.ReactElement {
  return (
    <Box
      mt={mt}
      width="100%"
      bg="white"
      borderRadius="12px"
      border="1px solid"
      borderColor="gray.200"
      overflow="hidden"
    >
      <Flex
        ref={bodyRef}
        direction="column"
        gap={6}
        px={6}
        pt={6}
        sx={{
          "& > *": {
            minWidth: 0,
          },
        }}
      >
        {children}
      </Flex>
      {footer && (
        <Box px={6} pb={6} pt={6}>
          {footer}
        </Box>
      )}
    </Box>
  );
}
